"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cryptos = [
    {
        coin_code: "BTC",
        coin_name: "Bitcoin",
        blockchains: [
            {
                code: "BTC",
                description: "Bitcoin",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "ETH",
        coin_name: "Ethereum",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "USDT",
        coin_name: "Tether",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "BUSD",
        coin_name: "BinanceUSD",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "BNB",
        coin_name: "Binance Coin",
        blockchains: [
            {
                code: "BNB",
                description: "Binance Chain (BEP2)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "LINK",
        coin_name: "ChainLink",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "LTC",
        coin_name: "Litecoin",
        blockchains: [
            {
                code: "LTC",
                description: "Litecoin",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "XRP",
        coin_name: "Ripple",
        blockchains: [
            {
                code: "XRP",
                description: "Ripple",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "EOS",
        coin_name: "EOS",
        blockchains: [
            {
                code: "EOS",
                description: "EOS",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "USDC",
        coin_name: "USD Coin",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "CHZ",
        coin_name: "Chiliz",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "BAT",
        coin_name: "Basic Attention Token",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "MANA",
        coin_name: "Decentraland",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "AAVE",
        coin_name: "Aave",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "COMP",
        coin_name: "Compound",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "ENJ",
        coin_name: "Enjin Coin",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "DOT",
        coin_name: "Polkadot",
        blockchains: [
            {
                code: "DOT",
                description: "Polkadot",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "MATIC",
        coin_name: "Polygon",
        blockchains: [
            {
                code: "MATIC",
                description: "Polygon",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "MCK",
        coin_name: "Mock Coin",
        blockchains: [
            {
                code: "MCK",
                description: "MCK",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "AVAX",
        coin_name: "Avalanche",
        blockchains: [
            {
                code: "AVAX-X",
                description: "Avalanche X-Chain",
                is_default: false,
            },
            {
                code: "AVAX-C",
                description: "Avalanche C-Chain",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "CELO",
        coin_name: "Celo",
        blockchains: [
            {
                code: "CELO",
                description: "Celo",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "DOGE",
        coin_name: "Dogecoin",
        blockchains: [
            {
                code: "DOGE",
                description: "DOGE",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "MKR",
        coin_name: "Maker",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "ADA",
        coin_name: "Cardano",
        blockchains: [
            {
                code: "ADA",
                description: "Cardano",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "CUSD",
        coin_name: "Celo Dollar",
        blockchains: [
            {
                code: "CELO",
                description: "Celo",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "CVC",
        coin_name: "Civic",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "DAI",
        coin_name: "Dai",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "ETC",
        coin_name: "Ethereum Classic",
        blockchains: [
            {
                code: "ETC",
                description: "ETC",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "FIL",
        coin_name: "Filecoin",
        blockchains: [
            {
                code: "FIL",
                description: "FIL",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "KLAY",
        coin_name: "Klaytn Chain",
        blockchains: [
            {
                code: "KLAY",
                description: "Klaytn",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "OMG",
        coin_name: "OmiseGo",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "SNX",
        coin_name: "Synthetix Network Token",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "SOL",
        coin_name: "Solana",
        blockchains: [
            {
                code: "SOL",
                description: "Solana",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "SUSHI",
        coin_name: "SushiSwap",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "UNI",
        coin_name: "Uniswap",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "WBTC",
        coin_name: "Wrapped Bitcoin",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "XLM",
        coin_name: "Stellar Lumens",
        blockchains: [
            {
                code: "XLM",
                description: "Stellar (XLM)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "YFI",
        coin_name: "yearn.finance",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "BCH",
        coin_name: "Bitcoin Cash",
        blockchains: [
            {
                code: "BCH",
                description: "Bitcoin Cash",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "AXS",
        coin_name: "Axie Infinity",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "ATOM",
        coin_name: "Cosmos",
        blockchains: [
            {
                code: "ATOM",
                description: "Cosmos",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "CAKE",
        coin_name: "PancakeSwap",
        blockchains: [
            {
                code: "BSC",
                description: "Binance Smart Chain (BEP20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "FLOW",
        coin_name: "Flow",
        blockchains: [
            {
                code: "FLOW",
                description: "Flow",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "FTM",
        coin_name: "Fantom",
        blockchains: [
            {
                code: "FTM",
                description: "Fantom",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "IMX",
        coin_name: "Immutable X",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "GRT",
        coin_name: "The Graph",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "NEAR",
        coin_name: "Near Protocol",
        blockchains: [
            {
                code: "NEAR",
                description: "NEAR Protocol",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "ONE",
        coin_name: "Harmony",
        blockchains: [
            {
                code: "ONE",
                description: "Harmony",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "USDP",
        coin_name: "Pax Dollar",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "XTZ",
        coin_name: "Tezos",
        blockchains: [
            {
                code: "XTZ",
                description: "Tezos",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "APE",
        coin_name: "ApeCoin",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "HBAR",
        coin_name: "Hedera",
        blockchains: [
            {
                code: "HBAR",
                description: "Hedera Hashgraph",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "WAXP",
        coin_name: "WAX",
        blockchains: [
            {
                code: "WAX",
                description: "WAX",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "SOLO",
        coin_name: "Sologenic",
        blockchains: [
            {
                code: "XRP",
                description: "Ripple",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "RUNE",
        coin_name: "THORChain",
        blockchains: [
            {
                code: "THORCHAIN",
                description: "Thorchain",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "CRO",
        coin_name: "Cronos",
        blockchains: [
            {
                code: "CRO",
                description: "Cronos",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "WAVES",
        coin_name: "Waves",
        blockchains: [
            {
                code: "WAVES",
                description: "Waves",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "HNT",
        coin_name: "Helium",
        blockchains: [
            {
                code: "HNT",
                description: "Helium",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "ALGO",
        coin_name: "ALGO",
        blockchains: [
            {
                code: "ALGO",
                description: "Algorand",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "LRC",
        coin_name: "Loopring",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "ZKS",
        coin_name: "ZKSpace",
        blockchains: [
            {
                code: "ZKS",
                description: "ZKSpace",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "BOBA",
        coin_name: "Boba Network",
        blockchains: [
            {
                code: "BOBA",
                description: "Boba Network",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "EGLD",
        coin_name: "Elrond",
        blockchains: [
            {
                code: "EGLD",
                description: "Elrond",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "MOB",
        coin_name: "MobileCoin",
        blockchains: [
            {
                code: "MOB",
                description: "MobileCoin",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "GMX",
        coin_name: "GMX",
        blockchains: [
            {
                code: "ARB",
                description: "Arbitrum",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "XCH",
        coin_name: "Chia",
        blockchains: [
            {
                code: "XCH",
                description: "Chia Chain",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "XPRT",
        coin_name: "Persistence",
        blockchains: [
            {
                code: "XPRT",
                description: "Persistence",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "RITE",
        coin_name: "Ritestream",
        blockchains: [
            {
                code: "BSC",
                description: "Binance Smart Chain (BEP20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "PSTAKE",
        coin_name: "pSTAKE Finance",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "TOR",
        coin_name: "TOR",
        blockchains: [
            {
                code: "FTM",
                description: "Fantom",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "HEC",
        coin_name: "Hector Network",
        blockchains: [
            {
                code: "FTM",
                description: "Fantom",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "KSM",
        coin_name: "Kusama",
        blockchains: [
            {
                code: "KSM",
                description: "Kusama",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "MOVR",
        coin_name: "Moonriver",
        blockchains: [
            {
                code: "MOVR",
                description: "Moonriver",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "EUROC",
        coin_name: "Euro Coin",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "BRWL",
        coin_name: "Blockchain Brawlers",
        blockchains: [
            {
                code: "WAX",
                description: "WAX",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "SAND",
        coin_name: "The Sandbox",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "TRX",
        coin_name: "TRON",
        blockchains: [
            {
                code: "TRON",
                description: "Tron (TRC20)",
                is_default: true,
            },
        ],
    },
    {
        coin_code: "VERSE",
        coin_name: "Verse",
        blockchains: [
            {
                code: "ETH",
                description: "Ethereum (ERC20)",
                is_default: true,
            },
            {
                code: "MATIC",
                description: "Polygon",
                is_default: true,
            },
        ],
    },
];
exports.default = cryptos;
//# sourceMappingURL=cryptos.js.map